import { styled, TableContainer, TableContainerProps } from "@mui/material";

export const TableWrapper = styled(TableContainer)<TableContainerProps>(() => {
	return {
		boxShadow: "none",
		"& .MuiTable-root": {
			borderCollapse: "separate",
		},
		"& .MuiTableCell-root": {
			fontFamily: "Inter",
			fontWeight: 600,
			fontSize: "14px",
			color: "var(--dark-color)",
			overflow: "hidden",
			whiteSpace: "normal",
			textOverflow: "ellipsis",
			maxWidth: "10rem",
			padding: "var(--basic-padding)",
			border: "1px solid var(--table-cell-border-color)",
		},
		"& .MuiTableHead-root": {
			"& .MuiTableCell-root": {
				fontFamily: "Poppins",
				fontWeight: 700,
				fontSize: "18px",
				borderTop: "none",
				borderBottom: "none",
				backgroundColor: "var(--table-header-bg-color)",
			},
			"& .MuiTableCell-root:first-of-type": {
				borderLeft: "none",
				borderTopLeftRadius: "16px",
			},
			"& .MuiTableCell-root:last-of-type": {
				borderRight: "none",
				borderTopRightRadius: "16px",
			},
		},
		"& .MuiTableBody-root": {
			"& .MuiTableRow-root": {
				"& .MuiTableCell-root:first-of-type": {
					borderLeft: "none",
				},
				"& .MuiTableCell-root:last-of-type": {
					borderRight: "none",
				},
			},
			"& .MuiTableRow-root:last-child": {
				"& .MuiTableCell-root": {
					borderBottom: "none",
				},
			},
		},
		"& .MuiTableFooter-root": {
			"& .MuiTableCell-root": {
				fontFamily: "Poppins",
				fontWeight: 700,
				fontSize: "18px",
				borderBottom: "none",
			},
			"& .MuiTableCell-root:first-of-type": {
				borderLeft: "none",
			},
			"& .MuiTableCell-root:last-of-type": {
				borderRight: "none",
			},
		},
	};
});
